import { render } from "./AlertingRule.vue?vue&type=template&id=776078db&scoped=true"
import script from "./AlertingRule.vue?vue&type=script&lang=js"
export * from "./AlertingRule.vue?vue&type=script&lang=js"

import "./AlertingRule.vue?vue&type=style&index=0&id=776078db&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-776078db"]])

export default __exports__